import { Component, OnInit, Input, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { SimDataService } from '../../services/sim-data.service';
import {Observable, BehaviorSubject, merge, of, from, combineLatest, Subscription, defer} from 'rxjs';
import { SimWithUsage, Sim } from '../../models/sim';
import {switchMap, mergeMap, toArray, map, tap} from 'rxjs/operators';
import { Operator } from '../../models/operator';
import { SimUsage } from '../../models/sim-usage';
import { DatePipe } from '@angular/common';
import { StateService } from '@uirouter/core';

@Component({
  selector: 'app-train-sims-usage',
  template: require('./train-sims-usage.component.html'),
  styles: [require('./train-sims-usage.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainSimsUsageComponent implements OnInit {

  @Input() projectId: number;
  @Input() trainId: number;
  
  sims$: Observable<SimWithUsage[]>;

  private readonly refreshTrainSimsList$ = new BehaviorSubject(undefined);
  
  constructor(
    private simDataService: SimDataService,
    private $state: StateService,
    private datePipe: DatePipe
  ) { 

      const sims$ = this.refreshTrainSimsList$.pipe(switchMap(() => this.simDataService.getSimsByTrain(this.projectId, this.trainId)));
      const operators$: Observable<Operator[]> = this.simDataService.getAllOperators(this.projectId);

      this.sims$ = combineLatest([sims$, operators$]).pipe(
        map(([sims,  operators]) => {
          return sims.map(sim => {
            const operator = operators.find(operator => operator.code === String(sim.simConfig.operatorCode));
            return {
              ...sim,
              simConfig: {
                ...sim.simConfig,
                operator: operator && operator.network
              }
            }
            
          })
        }))
  }

  ngOnInit(): void {
  }

  reload = () => {
    this.refreshTrainSimsList$.next(undefined);
  }

  viewSimDetails(sim: Sim | SimWithUsage) {
    this.$state.go('sim-overview-detail', {
      projectId: sim.projectId, 
      iccid: sim.iccid,
      from: this.datePipe.transform(sim.simConfig.currentBeginPeriod, "yyyy-MM-dd'T'HH:mm:ssZZZZZ"),
      to: this.datePipe.transform(sim.simConfig.currentEndPeriod, "yyyy-MM-dd'T'HH:mm:ssZZZZZ")
    });
  }

}
